import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

export const PublicSiteFrame = ({ children }) => {
  return (
    <Box pl={2} pr={2}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>{children}</Grid>
      </Grid>
    </Box>
  );
};
